import { gql } from '@apollo/client';

export const USER_ROLE_FRAGMENT = gql`
  fragment UserRoleFields on UserRole {
    id
    userId
    roleId
    role { name }
  }
`;
